export default __webpack_public_path__ + "static/media/Front-Apartment-Mr-Mazloum.60897543.jpg";